import compose from 'react-hooks-compose'

import { useUsuarioPageHeaderLogic } from './useLogic'
import { UsuarioPageHeaderPresenter } from './presenter'

export const UsuarioPageHeader = compose(props => ({
	useLogic: () => useUsuarioPageHeaderLogic(props),
}))(UsuarioPageHeaderPresenter)
